import React from 'react'
import { FormikSetFieldValue, ModalEditLayoutFields } from '../../../../../types/types'
import SwitchCheckbox from '../../../../UI/SwitchCheckbox/SwitchCheckbox'

type RequiredSwitchProps = {
    value: ModalEditLayoutFields['isRequired']
    setFieldValue: FormikSetFieldValue<ModalEditLayoutFields>
}

const RequiredSwitch: React.FC<RequiredSwitchProps> = React.memo(({ value, setFieldValue }) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | undefined) => {
        const target = e?.target
        if (target) {
            setFieldValue('isRequired', target.checked)
            if (!target.checked) {
                setFieldValue('requiredFrom', '')
                setFieldValue('requiredTo', '')
            }
        }
    }

    return (
        <SwitchCheckbox
            text='Обязательный макет'
            checked={value}
            classes={['edit-layout-switch-create']}
            onChange={handleChange}
        />
    )
})

export default RequiredSwitch